import {Konfigurasjon} from "felles/infrastruktur/Konfigurasjon";
import _ from "lodash";

export function telefonnummerFormatFilterForInjisering() {
        return [Konfigurasjon.regNavn, telefonnummerFormatFilter];
    }

    export function telefonnummerFormatFilter():Function {
        return function (mobilnummer:string) {

            let norskNummerMedLandKode:RegExp = /^(\+\d{2})(\d{3})(\d{2})(\d{3})$/;
            let norskNummerUtenLandkode = /^(\d{3})(\d{2})(\d{3})$/;

            if (_.isUndefined(mobilnummer) || _.isNull(mobilnummer))
                return '';

            else if(norskNummerMedLandKode.test(mobilnummer)) {
                let nummer = norskNummerMedLandKode.exec(mobilnummer);
                return nummer.slice(1).join(" ");
            }

            else if(norskNummerUtenLandkode.test(mobilnummer)) {
                let nummer = norskNummerUtenLandkode.exec(mobilnummer);
                return nummer.slice(1).join(" ");
            }

            else {
                return mobilnummer;
            }
        };
    }
